/**
 * CONEO-WD機能ルートパス
 */
export const coneoWdRoot = 'wd';

/**
 * CONEO-WD機能のメニュー定義
 */
export const coneoWdConfig: {label: string; menuItems: {label: string, path: string}[]} = {
    label: 'CONEO-WD2B',
    menuItems: [
      { label: '出荷手法選択', path: coneoWdRoot + '/dashboards' },
      { label: 'KPI', path: coneoWdRoot + '/kpi' },
      { label: '設定', path: coneoWdRoot + '/settings' }
    ],
};
